module.exports = __webpack_public_path__ + "img/planta_07.b3d06cc3.png";